import {
	Container, Divider,
	Grid, Typography
} from '@material-ui/core';
import {
	BackspaceOutlined as BackspaceOutlinedIcon,
	Print as PrintIcon
} from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SelectPartNumber from '../../components/Form/SelectPartNumber';
import SelectSupplier from '../../components/Form/SelectSupplier';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { ShippingRequestReportParams } from '../../interfaces/ShippingRequest';
import ReportApi from '../../services/ReportApi';
import { useStyles } from '../../utils/DefaultStyles';
import permissions from '../../utils/Permissions';
import SelectMvmStatus from '../Mvm/components/SelectStatus';
import Select from '../../components/Form/Select';

const ShippingRequestReport: React.FC = () => {
	const classes = useStyles();
	const { user, hasPermission } = useAuth();
	const { t: _t } = useTranslation('General');
	const { t } = useTranslation('Reports');
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		if (!hasPermission(permissions.REPORTS.ShippingRequest))
			history.replace('/NoPermission');
	}, [history, user]);

	//Campos do Form
	interface IFormPanel {
		suppliers: any;
		partNumber: any;
		status: any;
		startDate: any;
		endDate: any;
		initialApprovalDate: any;
		endApprovalDate: any;
        renderType: any;
	}

	//Metodos do form:
	const { handleSubmit, reset, control, clearErrors, getValues } =
		useForm<IFormPanel>({
			defaultValues: {
				startDate: '',
				endDate: '',
				initialApprovalDate: '',
				endApprovalDate: '',
				suppliers: [],
				partNumber: [],
				status: [],
				renderType: {code: '2', label: 'Excel'}
			},
		});

	const onSubmit = async (data: any) => {
		var validForm = await formValidation(data);
		if (validForm === false) return;

		data.supplierNames = data.suppliers.map(
			(x: any) => x.code + ' - ' + x.name
		);
		data.supplierIds = data.suppliers.map((x: any) => x.code);
		data.companyId = user.company.companyID;
		data.userName = user.name;

		ReportApi.printBusinessSecurity(data);
	};

	const cleanFilters = () => {
		reset();
	};

	const formValidation = async (data: any) => {
		var result = false;
		clearErrors();
		// try {
		// 	const schema = Yup.object().shape({
		// 		mvmNumber: Yup.number()
		// 			.nullable(true)
		// 			.typeError(tval('mustBeNumber'))
		// 			.transform(YupValidateNullableNumber), //transformar valor vazio em null
		// 	});

		// 	await schema.validate(data, {
		// 		abortEarly: false,
		// 	});

		// 	result = true;
		// } catch (err) {
		// 	var errors: string[] = [];

		// 	if (err instanceof Yup.ValidationError) {
		// 		err.inner.forEach((error) => {
		// 			if (
		// 				errors.filter((element) =>
		// 					element.includes(error.message)
		// 				).length == 0
		// 			)
		// 				errors.push(error.message);

		// 			setError(error.path?.split('.')[0] as 'mvmNumber', {
		// 				message: error.message,
		// 			});
		// 		});

		// 		errors.forEach((element) => {
		// 			if (element === tval('requiredField'))
		// 				enqueueSnackbar(_t('requiredFieldsValidation'), {
		// 					variant: 'warning',
		// 				});
		// 			else enqueueSnackbar(element, { variant: 'warning' });
		// 		});
		// 	}

		// 	result = false;
		// }
		return result;
	};

	async function generateReport(data: any) {
		if (await formValidation(data)) {
			enqueueSnackbar(_t('requiredFieldsValidation'), {
				variant: 'warning',
			});
			return;
		}

		var params: ShippingRequestReportParams = {
			companyId: +user.company.companyID,
			startDate: data?.startDate,
			endDate: data?.endDate,
			initialApprovalDate: data?.initialApprovalDate,
			endApprovalDate: data?.endApprovalDate,
			partNumberId: [data.partNumber.map((item: any) => item.code)],
			PartNumberDescription: [
				data.partNumber.map((item: any) => item.name),
			],
			status: [data.status.map((item: any) => item.code)],
			statusDescription: [data.status.map((item: any) => item.label)],
			supplierIds: [data.suppliers.map((item: any) => item.code)],
			SupplierNames: [data.suppliers.map((item: any) => item.name)],
			renderType: data.renderType.code
		};

		ReportApi.printShippingRequestReport(params);
	}

	return (
		<Container maxWidth={false} component='main'>
			<PageTitle
				title={t('pageTitle') + t('shippingRequest.pageTitle')}
			/>

			<div className={classes.rootContent}>
				<div className={classes.paper}>
					<form
						translate={undefined}
						onSubmit={handleSubmit(onSubmit)}
					>
						<Grid container spacing={1}>
							<Grid
								item
								xs={6}
								style={{
									padding: '0px',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<Typography className={classes.root}>
									{t('titleParameters')}
								</Typography>
							</Grid>

							<Grid
								item
								xs={6}
								style={{ padding: '0px', textAlign: 'right' }}
							>
								<ButtonUI
									onClick={() => cleanFilters()}
									startIcon={<BackspaceOutlinedIcon />}
								>
									{_t('clean')}
								</ButtonUI>
								<ButtonUI
									disabled={
										!hasPermission(permissions.SHED.Add)
									}
									color='primary'
									onClick={() => generateReport(getValues())}
									startIcon={<PrintIcon />}
								>
									{t('print')}
								</ButtonUI>
							</Grid>
						</Grid>

						<Divider style={{ marginTop: '10px' }} />

						<Grid container spacing={1}>
							<Grid item xs={3}>
								<SelectSupplier
									label={t('shippingRequest.supplier')}
									name='suppliers'
									control={control}
									multiple={true}
									fullWidth
									// style={{width: '100%'}}
								/>
							</Grid>

							<Grid item xs={2}>
								<SelectPartNumber
									label={t('shippingRequest.partNumber')}
									name={'partNumber'}
									control={control}
									multiple={true}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<SelectMvmStatus
									label={t('shippingRequest.status')}
									name='status'
									context='AEStatusRequisicao'
									control={control}
									multiple={true}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<TextField
									label={t('shippingRequest.startDateRequest')}
									name='startDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<TextField
									label={t('shippingRequest.endDateRequest')}
									name='endDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<TextField
									label={t(
										'shippingRequest.startApprovalDate'
									)}
									name='initialApprovalDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>

							<Grid item xs={2}>
								<TextField
									label={t('shippingRequest.endApprovalDate')}
									name='endApprovalDate'
									control={control}
									type='date'
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
							</Grid>


                            <Grid item xs={1}>
                                <Select
                                    label={_t("reportExportType")} 
                                    name="renderType"
                                    control={control} 
                                    options={[{code: '2', label: 'Excel'}, {code: '1', label: 'PDF'}]}
                                    style={{width: '100%'}}/>
                            </Grid>
						</Grid>
					</form>
				</div>
			</div>
		</Container>
	);
};
export default ShippingRequestReport;
